<p-dialog [visible]="true" [closable]="false" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<p-header>
		<div class="h3">Group Setup</div>
	</p-header>
	<div *ngIf="customerGroupValue" class="d-flex mx-2 justify-content-center">
		{{ customerGroupValue }}
	</div>

	<div class="d-flex flex-fill mx-2 mt-4">
		<span class="p-float-label flex-fill">
			<input required #name pInputText type="text" name="name" [(ngModel)]="customerGroup.name" class="w-100 flex-fill" />
			<label for="name">Group Name</label>
		</span>
	</div>
	<div class="d-flex flex-fill mx-2 mt-4">
		<span class="p-float-label flex-fill">
			<textarea pInputText #description name="description" [(ngModel)]="customerGroup.description" class="w-100"></textarea>
			<label for="description">Description</label>
		</span>
	</div>
	<div class="d-flex w-100 text-center">
		<div class="mx-auto">
			<p-selectButton [options]="type" optionValue="value" optionLabel="label" [(ngModel)]="customerGroup.type" styleClass="mx-auto"></p-selectButton>
		</div>
	</div>

	<form #f="ngForm" autocomplete="off">
		<ng-container *ngIf="customerGroup.type === 1">
			<div class="d-flex flex-fill mx-2 mt-4">
				<div class="d-flex flex-fill">
					<span class="p-float-label flex-fill">
						<p-dropdown
							required
							#criteriaSelect
							autocom
							[autoDisplayFirst]="false"
							[options]="criteria"
							optionLabel="label"
							optionValue="value"
							name="criteriaSelect"
							[(ngModel)]="customerGroup.criteria"
							appendTo="body"
							(onChange)="filterCriteria()"
							styleClass="w-100"
						>
						</p-dropdown>
						<label for="criteriaSelect">Criteria</label>
					</span>
				</div>
				<div class="d-flex flex-fill mx-2">
					<span class="flex-fill">
						<p-dropdown
							#operatorSelect
							[options]="operator"
							optionLabel="label"
							optionValue="value"
							name="operatorSelect"
							[(ngModel)]="customerGroup.operator"
							appendTo="body"
							styleClass="w-100"
						>
						</p-dropdown>
					</span>
				</div>
			</div>
			<div *ngIf="customerGroup.criteria !== 6 && customerGroup.criteria !== 5 && customerGroup.criteria !== 4" class="d-flex flex-fill mx-2 mt-4">
				<span class="p-float-label flex-fill">
					<p-inputNumber #valueSelect name="valueSelect2" [(ngModel)]="customerGroup.value" styleClass="w-100"></p-inputNumber>
					<label *ngIf="customerGroup.operator !== 6" for="valueSelect">Compare Value</label>
					<label *ngIf="customerGroup.operator === 6" for="valueSelect">Value 1</label>
				</span>
				<span *ngIf="customerGroup.operator === 6" class="p-float-label flex-fill">
					<p-inputNumber #valueSelect2 name="valueSelect2" [(ngModel)]="customerGroup.value2" styleClass="w-100"></p-inputNumber>
					<label for="valueSelect2">Value 2</label>
				</span>
			</div>
			<div *ngIf="customerGroup.criteria === 4 || customerGroup.criteria === 5" class="d-flex flex-fill mx-2 mt-4">
				<span class="p-float-label flex-fill me-2">
					<p-calendar
						#customerGroupVisitDatePick
						name="customerGroupVisitDatePick"
						[(ngModel)]="customerGroup.value"
						appendTo="body"
						styleClass="w-100"
						[showTime]="false"
					></p-calendar>
					<label for="customerGroupVisitDatePick">Visit Date</label>
				</span>
				<span *ngIf="customerGroup.operator === 6" class="p-float-label flex-fill">
					<p-calendar
						#customerGroupVisitDatePick2
						name="customerGroupVisitDatePick2"
						[(ngModel)]="customerGroup.value2"
						appendTo="body"
						styleClass="w-100"
						[showTime]="false"
					></p-calendar>
					<label for="customerGroupVisitDatePick2">Visit Date 2</label>
				</span>
			</div>
			<div *ngIf="customerGroup.criteria === 6" class="d-flex flex-fill mx-2 mt-4">
				<span class="p-float-label flex-fill">
					<p-dropdown
						required
						#value
						[autoDisplayFirst]="false"
						[options]="menuItemList"
						optionLabel="GuestCheckName"
						optionValue="RecordNumber"
						name="menuItemlist"
						[(ngModel)]="customerGroup.value"
						styleClass="w-100 flex-fill"
						appendTo="body"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						[filter]="true"
						filterBy="RecordNumber,GuestCheckName"
					></p-dropdown>
					<label for="value">Menu Item</label>
				</span>
			</div>
		</ng-container>
	</form>
	<ng-container *ngIf="customerGroup.type === 2">
		<p-multiSelect
			[options]="customerList"
			optionLabel="name"
			[virtualScroll]="true"
			virtualScrollItemSize="30"
			styleClass="w-100"
			optionLabel="displayName"
			optionValue="key"
			[(ngModel)]="customerGroup.customerKeyList"
			[showToggleAll]="true"
			[filter]="true"
			[filterBy]="app.keys(customerList)"
			appendTo="body"
		>
			<ng-template let-rec pTemplate="item">
				<div class="d-flex">
					{{ rec.displayName }}
				</div>
			</ng-template>
		</p-multiSelect>
	</ng-container>
	<ng-container *ngIf="customerGroup.type === 3">
		<div class="w-100">
			<span class="display-12 text-italics"> All customers will be included in this group. </span>
		</div>
	</ng-container>

	<div class="d-flex flex-column mt-4 w-100">
		<p-divider>Additional email addresses</p-divider>
		<span class="p-float-label p-fluid w-100">
			<p-chips
				#adhocEmailAddressList
				id="adhocEmailAddressList"
				[(ngModel)]="customerGroup.adhocEmailAddressList"
				styleClass="p-fluid w-100"
				addOnTab="true"
				addOnBlur="true"
				showClear="true"
				allowDuplicate="false"
				separator=","
				styleClass="w-100"
				placeholder="johndoe@example.com"
			></p-chips>
		</span>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideSave]=""
			(onCancelChange)="onClear.emit(true)"
			(onSaveChange)="save()"
			(onDeleteChange)="delete()"
			[cancelDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
